/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { Entitlement } from "./Entitlement";

/**
 * A user's full entitlement picture at one moment — the result of the reduction.
 */
export interface EntitlementState {
  entitlements: Entitlement[];
}
